/* src/app/modules/user/partnersequity/partners/partners-list.component.css */
/*# sourceMappingURL=partners-list.component.css.map */
